import { IInvertsCategory } from "../../model/Category";

export const inverts: IInvertsCategory = [
    {
        id: 1,
        name: "Skunk cleaner shrimp (large)",
        description: "Gros cleaner shrimp: large cleaner shrimp",
        price: 40,
        imageUrl: ["/images/inverts/Skunk cleaner shrimp.JPG"],
        variants: [],
        isAvailable: true
    },
    {
        id: 2,
        name: "White pincushion urchin (large)",
        description: "Gros oursin pincushion blanc, excellent nettoyeur d'algue. Large pincushion urchin, excellent algae cleaner",
        price: 35,
        imageUrl: ["/images/inverts/White pincushion urchin.png"],
        variants: [],
        isAvailable:true
    }
];
